import global from "@/locales/lt-LT/global";
import error403 from "@/locales/lt-LT/errors/403";
import error404 from "@/locales/lt-LT/errors/404";
import error500 from "@/locales/lt-LT/errors/500";
import error503 from "@/locales/lt-LT/errors/503";
import error504 from "@/locales/lt-LT/errors/504";
import maintenance from "@/locales/lt-LT/auth/maintenance";
import toast from "@/locales/lt-LT/toast/toast";
import login from "@/locales/lt-LT/auth/login";
import onboarding from "@/locales/lt-LT/auth/onboarding";
import loginPageSteps from "@/locales/lt-LT/loginPageSteps";
import dashboard from "@/locales/lt-LT/dashboard/dashboard";
import account from "@/locales/lt-LT/account/account";
import mailbox from "@/locales/lt-LT/account/mailbox";
import bankstatement from "@/locales/lt-LT/account/bankstatement";
import myApps from "@/locales/lt-LT/my-apps/myApps";
import about from "@/locales/lt-LT/about/about";
import contactService from "@/locales/lt-LT/about/contactService";
import salesPromotions from "@/locales/lt-LT/sales/promotions";
import brochures from "@/locales/lt-LT/sales/brochures";
import shop from "@/locales/lt-LT/shop/data";
import priceList from "@/locales/lt-LT/shop/priceList";
import staff from "@/locales/lt-LT/dashboard/staff";
import promotions from "@/locales/lt-LT/promotions";
import points from "@/locales/lt-LT/points";
import trainings from "@/locales/lt-LT/trainings/trainings";
import vouchers from "@/locales/lt-LT/vouchers/vouchers";
import media from "@/locales/lt-LT/media/index";
import product from "@/locales/lt-LT/product/index";
import message from "@/locales/lt-LT/message/index";
import commitmentLetter from "@/locales/lt-LT/account/commitmentLetter";
import multiplicator from "@/locales/lt-LT/multiplicator";
import widgets from "@/locales/lt-LT/widgets/widgets";
import consents from "@/locales/lt-LT/consents/consents";
import investment from "@/locales/lt-LT/investment/data";
import kickback from "@/locales/lt-LT/kickback";
//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Produktų nuotraukos",
    BDriveLinkText: "Nuoroda į PRODUKTŲ NUOTRAUKŲ portalą",
  },
}

export default {
  locale: "lt-LT",
  messages,
};
